
import { AdminProfileResponse, IExamMasterCodeItem } from '../../api/user/model';
import { GET_ADMIN_PROFILE_DETAIL_URL } from '../../constants/apiUrls';
import { GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import { AdminProfileFormData } from '../../models';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import dayjs from 'dayjs';

export const useGetAdminProfileDetails = () => {
  const getAdminProfileDetails = async () => {
    const res = await axiosClient.get<AdminProfileResponse>(GET_ADMIN_PROFILE_DETAIL_URL);
    const convertedData: AdminProfileFormData = {
      adminId: res.data?.adminId,
      dateOfBirth: res.data?.dateOfBirth,
      email: res.data?.email,
      mobileContactNumber: res.data?.mobileNumber?.number,
      mobileCountryCode: res.data?.mobileNumber?.countryCode as IExamMasterCodeItem,
      photoUrl: res.data?.photoUrl,
      photoUUid: res.data?.photoUuid,
      statutoryName: res.data?.statutoryName,
      userIdType: res.data?.userIdType,
      accountType: res.data?.accountType,
    };
    return convertedData;
  };

  return useCustomQuery(GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY, getAdminProfileDetails);
};
